import React, { useState, useEffect } from "react";
import "./adminEvent.css";
import { createEvent, updateEvent } from "./adminEventService";
import { fetchActiveSpeakers } from "../services/adminSpeakerServices";

const AdminEventForm = ({ event, onSaved, onCancel }) => {

  /**
   * =========================
   * DATE HELPERS
   * =========================
   */

  const convertUTCToLocalInput = (utcString) => {

    try {

      if (!utcString) return "";

      const date = new Date(utcString);

      const offset = date.getTimezoneOffset();

      const local = new Date(date.getTime() - offset * 60000);

      return local.toISOString().slice(0, 16);

    } catch (error) {

      console.error("UTC to local conversion error:", error);

      return "";

    }

  };

  const convertToUTCOffsetDateTime = (localDateTime) => {

    try {

      if (!localDateTime) return null;

      const localDate = new Date(localDateTime);

      return localDate.toISOString();

    } catch (error) {

      console.error("Local to UTC conversion error:", error);

      return null;

    }

  };

  /**
   * =========================
   * INITIAL STATE
   * =========================
   */

  const [formData, setFormData] = useState({

    title: event?.title || "",

    description: event?.description || "",

    eventDate: convertUTCToLocalInput(event?.eventDate),

    eventStartTime: convertUTCToLocalInput(event?.eventStartTime),

    eventDuration: event?.eventDuration || 40,

    speakerId: event?.speakerId || "",

    /**
     * IMPORTANT FIX
     */
    cancelled: event?.cancelled ?? false

  });

  /**
   * =========================
   * NEW STATE: SPEAKERS LIST
   * =========================
   */
  const [speakers, setSpeakers] = useState([]);

  /**
   * =========================
   * FETCH SPEAKERS
   * =========================
   */
  useEffect(() => {

    const loadSpeakers = async () => {

      try {

        const response = await fetchActiveSpeakers();

        if (response.status === 200) {

          setSpeakers(response.data);

        } else {

          console.error("Failed to fetch speakers");

        }

      } catch (error) {

        console.error("Speaker fetch error:", error);

      }

    };

    loadSpeakers();

  }, []);

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

  /**
   * =========================
   * SUBMIT
   * =========================
   */

  const handleSubmit = async (e) => {

    e.preventDefault();

    const payload = {

      ...formData,

      eventDate: convertToUTCOffsetDateTime(formData.eventDate),

      eventStartTime: convertToUTCOffsetDateTime(formData.eventStartTime),

      eventDuration: parseInt(formData.eventDuration),

      speakerId: formData.speakerId ? parseInt(formData.speakerId) : null,

      /**
       * IMPORTANT FIX
       */
      cancelled: formData.cancelled ?? false

    };

    console.log("Submitting payload:", payload);

    let response;

    if (event?.id) {

      response = await updateEvent(event.id, payload);

    } else {

      response = await createEvent(payload);

    }

    if (response.status === 200 || response.status === 201) {

      onSaved();

    } else {

      alert(response.message);

    }

  };

  return (

    <div className="form-card">

      <div className="form-header">
        <h2>{event ? "Edit Event" : "Create Event"}</h2>
      </div>

      <form onSubmit={handleSubmit} className="form-grid">

        <div className="form-group">
          <label>Title</label>
          <input
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Duration (mins)</label>
          <input
            type="number"
            name="eventDuration"
            value={formData.eventDuration}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Event Date</label>
          <input
            type="datetime-local"
            name="eventDate"
            value={formData.eventDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Start Time</label>
          <input
            type="datetime-local"
            name="eventStartTime"
            value={formData.eventStartTime}
            onChange={handleChange}
            required
          />
        </div>

        {/* =========================
            NEW: SPEAKER DROPDOWN
           ========================= */}

        <div className="form-group">
          <label>Speaker</label>

          <select
            name="speakerId"
            value={formData.speakerId}
            onChange={handleChange}
            required
          >

            <option value="">Select Speaker</option>

            {speakers.map((speaker) => (

              <option key={speaker.id} value={speaker.id}>
                {speaker.name}
              </option>

            ))}

          </select>

        </div>

        <div className="form-group full-width">
          <label>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        <div className="form-actions full-width">

          <button type="submit" className="btn primary">
            {event ? "Update Event" : "Create Event"}
          </button>

          <button
            type="button"
            className="btn secondary"
            onClick={onCancel}
          >
            Cancel
          </button>

        </div>

      </form>

    </div>

  );

};

export default AdminEventForm;